import React from 'react'
import heart from '../../assets/icons/heart.png'

const Footer = () => {
    return (
        <div className="flex justify-center bg-gray-900 px-4 py-4 baloo text-center text-white font-semibold tracking-widest">
            Made with <img src={heart} alt="" className='h-6 mx-3' /> by Sai Charan
        </div>
    )
}

export default Footer
